<template>
  <TsModal
    append-class="p-6 mx-4 max-w-[75%] xl:max-w-lg relative"
    v-model:visible="trolleyStore.move_all_to_savelist_modal_visible"
  >
    <template #modal-content>
      <div
        class="mx-auto bg-natural-soft-white rounded-full flex justify-center items-center w-[60px] h-[60px] mb-6"
      >
        <TsIcon
          class="text-danger"
          name="material-symbols:delete-outline"
          width="40"
          height="40"
        />
      </div>

      <TsIcon
        class="text-idle-black cursor-pointer absolute top-6 right-6"
        name="charm:cross"
        size="24"
        @click="trolleyStore.move_all_to_savelist_modal_visible = false"
      />
      <TsTypography as="h2" variant="h1" align="center">
        {{
          useTranslation(
            "areYouSureTrolleySavelistModal",
            "Weet u zeker dat u uw trolley naar de bewaarlijst wilt verplaatsen?"
          )
        }}
      </TsTypography>

      <TsTypography append-class="mx-auto md:max-w-[90%]" align="center">
        {{
          useTranslation(
            "warningTrolleyDelete",
            "Deze actie is onomkeerbaar en verwijdert permanent alle items uit de trolley. Weet u zeker dat u verder wilt gaan?"
          )
        }}
      </TsTypography>

      <div class="flex gap-3 mt-8">
        <TsButton
          :label="useTranslation('cancel', 'Annuleren')"
          @click="trolleyStore.move_all_to_savelist_modal_visible = false"
          block
          variant="secondary"
          outlined
        />
        <TsButton
          :label="useTranslation('yesMove', 'Ja, bewegen')"
          variant="danger"
          block
          :link="authStore.is_authenticated ? undefined : '/login'"
          @click="moveAllItemsToSaveList"
        />
      </div>
    </template>
  </TsModal>
</template>

<script lang="ts" setup>
import { EventConstants } from "~/assets/constants/ecomApi";
import { useTranslation } from "~/composables/useTranslation";

const trolleyStore = useTrolleyStore();
const authStore = useAuthStore();

const trolleyDetails: Record<string, any> = {
    isIncVat: useRootStore().isIncVat,
    items: [],
    value: 0,
    value_excluding_tax:0,
  };

async function moveAllItemsToSaveList() {
  if (!authStore.is_authenticated) return;
  const { moveAllTrolleyItemsToSavelist } = await import(
    "~/stores-datalayer/trolley.datalayerv2"
  );

  logEvent({
    options: {
      eventAction: "click",
      eventProperties: "",
      ecommerce:{
        value: trolleyDetails.value,
        value_excluding_tax: trolleyDetails.value_excluding_tax,
        currency: EventConstants.currency,
        item_list_name: "Related products",
        item_list_id: "related_products",
        items: trolleyDetails.items,
      },
      eventInteraction: true,
      eventLabel: `trolley_save_in_list`,
      eventName: "trolley_save_in_list",
    },
  });

  trolleyStore.move_all_to_savelist_modal_visible = false;
  moveAllTrolleyItemsToSavelist();
}
</script>
